import { useCallback } from 'react';
import { useLocation } from 'react-router';
import { useClientContext } from 'client/context';
import { setCandleValidations } from 'ducks/candle-validations/slices';
import { updateSettings } from 'ducks/settings/slices';
import { useAppDispatch } from 'store/hooks';
import { parseQuery } from 'utils/queries';

import { JobsQuery } from './types';

const useValidationsApi = () => {
  const { search } = useLocation();
  const dispatch = useAppDispatch();
  const { Voladeum, handleError } = useClientContext();

  const getData = useCallback(async () => {
    try {
      dispatch(updateSettings({ loading: true }));
      const {
        candle_validation_adapter_ids,
        candle_validation_pair_ids,
        candle_validation_status_ids,
      } = parseQuery<JobsQuery>(search);

      const [voladeum_validations] = await Promise.all([
        Voladeum.candleValidations.list({
          adapter_ids: candle_validation_adapter_ids || [],
          status_ids: candle_validation_status_ids || [],
          pair_ids: candle_validation_pair_ids || [],
        }),
      ]);

      dispatch(setCandleValidations(voladeum_validations.data));
      dispatch(updateSettings({ loading: false }));
    } catch (err) {
      handleError(err);
    }
  }, [dispatch, search, Voladeum, handleError]);

  return { getData };
};

export { useValidationsApi };
